import React from 'react';
import { Box, Typography } from '@mui/material';

// Shared status vocabulary for irn_status / eway_bill_status — same dot +
// label wherever GST e-invoice status shows up in this app (payment success
// overlay, Order History detail).
const STATUS_MAP = {
  generated:    { label: 'Generated',   color: '#16A34A' },
  pending:      { label: 'Pending',     color: '#D97706' },
  failed:       { label: 'Failed',      color: '#DC2626' },
  not_required: { label: 'Not required', color: '#94A3B8', outline: true },
  none:         { label: 'Not yet generated', color: '#94A3B8', outline: true },
};

export default function EinvoiceStatus({ status }) {
  const s = STATUS_MAP[status] ?? STATUS_MAP.none;
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6 }}>
      <Box sx={{
        width: 7, height: 7, borderRadius: '50%', flexShrink: 0,
        bgcolor: s.outline ? 'transparent' : s.color,
        border: s.outline ? `1.5px solid ${s.color}` : 'none',
      }} />
      <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: s.color }}>
        {s.label}
      </Typography>
    </Box>
  );
}
